




























































import Vue from 'vue'
import TypeIcons from '@/components/InstallDevices/TypeIcons.vue'
import UnderlineTextButton from '@/components/Global/UnderlineTextButton.vue'
import Loader from '@/components/Global/Loader.vue'
import { presetsForm, rules } from './constants'
import {
  apiGetPresetDetails,
  apiUpdatePreset,
  apiCreatePreset,
  apiDeletePreset,
  apiDropdownsEntityModels,
  apiDropdownsEntityEngineModels
} from '@/api'
import { mutations } from '@/state'

export default Vue.extend({
  name: 'ManagePresetsDialog',
  components: { TypeIcons, UnderlineTextButton, Loader },
  props: {
    managePresetsModalOpened: Boolean,
    presets: Array,
    colors: Array,
    brands: Array,
    engineBrands: Array,
    maintenancePlans: Array,
    types: Array,
    tags: Array
  },
  data () {
    return {
      loadingPreset: false,
      modalActive: false,
      formDisabled: true,
      editMode: false,
      models: [],
      engineModels: [],
      preset: null,
      form: { ...presetsForm },
      rules
    }
  },
  methods: {
    close () {
      this.$emit('closeManagePresetsModal')
      this.reset()
    },
    brandHandler (brand: { id: string; name: string }) {
      if (brand?.id) {
        this.form.brand = brand.name
        this.form.brand_id = brand.id
        apiDropdownsEntityModels(brand.id).then(res => {
          this.models = res.data.data
        })
      } else {
        this.models = []
      }
    },
    engineBrandHandler (brand: { id: string; name: string }) {
      if (brand?.id) {
        this.form.engine_brand = brand.name
        this.form.engine_brand_id = brand.id
        apiDropdownsEntityEngineModels(brand.id).then(res => {
          this.engineModels = res.data.data
        })
      } else {
        this.engineModels = []
      }
    },
    createPreset () {
      mutations.setSnackbar()
      apiCreatePreset(this.form).then(() => {
        mutations.setSnackbar('success', this.t({s: 'success', component: 'Snackbar'}))
        this.reset()
        this.getPresets()
      }).catch(e => mutations.setSnackbar('error', e.response.data.message))
    },
    getPresets () {
      this.$emit('getPresets')
    },
    updatePreset () {
      mutations.setSnackbar()
      apiUpdatePreset(this.preset.id, this.form).then(() => {
        mutations.setSnackbar('success', this.t({s: 'success', component: 'Snackbar'}))
        this.reset()
      }).catch(e => mutations.setSnackbar('error', e.response.data.message))
    },
    async deletePreset () {
      const { isConfirmed } = await this.sweetAlert(this.t({ s: 'confirmText', component: 'messages' }, [this.preset.name]))
      if (!isConfirmed) return
      try {
        mutations.setSnackbar()
        apiDeletePreset(this.preset.id).then(() => {
          mutations.setSnackbar('success', this.t({s: 'success', component: 'Snackbar'}))
          this.reset()
        })
      } catch (e) {
        mutations.setSnackbar('error', e.response.data.message)
      }
    },
    reset () {
      this.form = { ...presetsForm }
      this.editMode = false
      this.getPresets()
    },
    toggleEditMode () {
      this.form = { ...presetsForm }
      this.preset = null
      this.editMode = !this.editMode
    }
  },
  watch: {
    managePresetsModalOpened (val) {
      this.modalActive = val
    },
    form: {
      handler () {
        this.formDisabled = !this.$refs.presetForm.validate()
      },
      deep: true
    },
    preset (presetObj) {
      if (!presetObj) return
      this.loadingPreset = true
      apiGetPresetDetails(presetObj.id).then(res => {
        const { type, type_id, preset_name, name, color, brand, brand_id, model, engine_brand, engine_brand_id, engine_model, maintenance_plan_id, tags } = res.data.data
        const { form } = this
        form.type = type
        form.type_id = type_id
        form.preset_name = preset_name
        form.name = name || ''
        form.color = color || ''
        form.model = model || ''
        form.engine_model = engine_model || ''
        form.maintenance_plan_id = maintenance_plan_id || null
        form.tags = tags.map((t: {name: string}) => t.name)
        this.brandHandler({ id: brand_id, name: brand })
        this.engineBrandHandler({ id: engine_brand_id, name: engine_brand })
        this.loadingPreset = false
      })
    }
  }
})
